import { render, staticRenderFns } from "./DailyByCategory.vue?vue&type=template&id=12a7b0d6&scoped=true"
import script from "./DailyByCategory.vue?vue&type=script&lang=js"
export * from "./DailyByCategory.vue?vue&type=script&lang=js"
import style0 from "./DailyByCategory.vue?vue&type=style&index=0&id=12a7b0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7b0d6",
  null
  
)

export default component.exports